// extracted by mini-css-extract-plugin
module.exports = {"root":"R97mk9HW"};